export default {
  // 表格列标题
  currency: "币种",
  keyActions: "关键行为",
  counterparty: "交易对手",
  transactionAmount: "交易数量",
  transactionTime: "交易时间",

  // 加载和状态
  loading: "拼命加载中",
  noData: "暂无数据",
  tooMuchData: "当前地址交易数据过多，暂时不支持此类数据的查看",

  // 消息提示
  copySuccess: "复制成功",
};
